import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../services/api';
import { trainingPath } from '../utils/paths';
import './PublicTrainingLog.css';

const PublicTrainingChallenge = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const result = await api.getPublicTrainingChallenge(token);
      setData(result);
    } catch (err) {
      setError(err.message || 'Failed to load challenge');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const handleWhatsApp = () => {
    if (!data) return;
    window.open(
      api.shareTrainingChallengeViaWhatsApp({
        challengeName: data.challengeName,
        clubName: data.clubName,
        shareToken: token,
        participantCount: data.leaderboard?.length || 0,
      }),
      '_blank'
    );
  };

  if (loading) {
    return <div className="public-training loading">Loading challenge…</div>;
  }

  if (error) {
    return (
      <div className="public-training">
        <div className="card">
          <div className="alert alert-error">{error}</div>
          <Link to={trainingPath()} className="btn btn-secondary">
            Open Training
          </Link>
        </div>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="public-training">
      <header className="public-training__hero">
        <p className="public-training__eyebrow">{data.clubName}</p>
        <h1>{data.challengeName}</h1>
        {data.description && <p>{data.description}</p>}
        <p className="public-training__summary">
          {data.startDate} – {data.endDate} · {data.templateId?.replace('_', ' ')}
        </p>
        <div className="public-training__actions">
          <button type="button" className="btn btn-primary" onClick={handleWhatsApp}>
            Share via WhatsApp
          </button>
          <Link to={trainingPath('/soccer/tracker')} className="btn btn-secondary">
            Join on Training
          </Link>
        </div>
      </header>

      <section className="public-training__panel">
        <h2>Leaderboard</h2>
        {!data.leaderboard?.length && (
          <p className="training-muted">No participants on the leaderboard yet.</p>
        )}
        <ol className="public-training__leaderboard">
          {(data.leaderboard || []).map((entry) => (
            <li key={entry.userId}>
              <span className="public-training__rank">#{entry.rank}</span>
              <div>
                <strong>{entry.displayName}</strong>
                <p>
                  {entry.completedSessions} sessions · {entry.currentStreak}-day streak ·{' '}
                  {entry.totalMinutes} min
                </p>
              </div>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
};

export default PublicTrainingChallenge;
